import { render } from "./UAppHeader.vue?vue&type=template&id=0217e1c6"
import script from "./UAppHeader.vue?vue&type=script&lang=ts"
export * from "./UAppHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script